import React, { Component } from 'react';
import DashboardHeader from '@/components/Header/DashboardHeader';
import { Footer } from '@/components/organisms/Footer';
import styles from './Legal.module.scss';

class CookiePolicy extends Component {
  render() {
    return (
      <div className={styles.legalPage}>
        <DashboardHeader />
        <div className={styles.legalContainer}>
          <article className={styles.legalCard}>
            <h1 className={styles.pageTitle}>Cookie Policy</h1>
            <p className={styles.lastUpdated}>Last updated: 31 July 2026</p>

            <p className={styles.intro}>
              This Cookie Policy explains how <span className={styles.entityName}>Chatup24 Global
              Technologies L.L.C-FZ</span> ("Chatup24", "we", "us" or "our") uses cookies, local
              storage and similar technologies when you use the Chatup24 platform at chatup24.com and
              our related mobile applications (the "Service"). It should be read together with our
              Privacy Policy. We handle any personal data collected through these technologies in
              accordance with the UAE Personal Data Protection Law — Federal Decree-Law No. 45 of
              2021 (the "PDPL").
            </p>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>1. What Are Cookies and Similar Technologies?</h2>
              <p className={styles.paragraph}>
                Cookies are small text files stored on your device. Similar technologies, such as
                browser local storage, let a website or app save information on your device. We use
                these technologies to keep you signed in, remember your preferences and operate the
                Service reliably.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>2. Technologies We Use</h2>
              <ul className={styles.list}>
                <li><strong>Essential and session storage:</strong> we use browser local storage to
                  maintain your session and keep you signed in as you navigate the Service.</li>
                <li><strong>Authentication tokens:</strong> we store secure tokens so you do not have
                  to log in on every action. We use Google and Firebase for authentication.</li>
                <li><strong>Preferences:</strong> we may store your settings and choices to give you a
                  consistent experience.</li>
                <li><strong>Notifications:</strong> we use Firebase Cloud Messaging to deliver push
                  notifications where you have enabled them.</li>
              </ul>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>3. Why We Use Them</h2>
              <p className={styles.paragraph}>
                These technologies are mainly essential: they allow you to sign in, place orders and
                bookings, chat with venues and use the core features of the Service securely. Without
                them, parts of the Service may not function correctly.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>4. Managing and Disabling Them</h2>
              <p className={styles.paragraph}>
                You can control or clear cookies and local storage through your browser or device
                settings, and you can manage push notifications through your device permissions.
                Please note that disabling essential storage may prevent you from signing in or using
                key features of the Service.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>5. Consent</h2>
              <p className={styles.paragraph}>
                By continuing to use the Service, you consent to our use of the cookies and similar
                technologies described in this policy, in accordance with the PDPL. Where required, we
                will seek your consent for any non-essential technologies, and you may withdraw your
                consent at any time by adjusting your browser or device settings.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>6. Changes to This Policy</h2>
              <p className={styles.paragraph}>
                We may update this Cookie Policy from time to time. When we do, we will revise the
                "Last updated" date above.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>7. Contact Us</h2>
              <p className={styles.paragraph}>If you have questions about this policy, contact us at:</p>
              <div className={styles.contactBlock}>
                <p className={styles.entityName}>Chatup24 Global Technologies L.L.C-FZ</p>
                <p>Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.</p>
                <p>Email: <a className={styles.link} href="mailto:privacy@chatup24.com">privacy@chatup24.com</a></p>
              </div>
            </section>
          </article>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CookiePolicy;
